"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoNumberField = void 0;
const joi_1 = __importDefault(require("joi"));
const field_types_1 = require("../../types/field_types");
const datasheet_1 = require("../datasheet");
const number_base_field_1 = require("./number_base_field");
const types_1 = require("../../types");
const validate_schema_1 = require("./validate_schema");
class AutoNumberField extends number_base_field_1.NumberBaseField {
    get apiMetaProperty() {
        return null;
    }
    get acceptFilterOperators() {
        return AutoNumberField._acceptFilterOperators;
    }
    static createDefault(fieldMap) {
        return {
            id: datasheet_1.DatasheetActions.getNewFieldId(fieldMap),
            type: field_types_1.FieldType.AutoNumber,
            name: datasheet_1.DatasheetActions.getDefaultFieldName(fieldMap),
            property: this.defaultProperty(),
        };
    }
    static defaultProperty() {
        return {
            nextId: 0,
            viewIdx: 0,
            datasheetId: '',
        };
    }
    get isComputed() {
        return true;
    }
    recordEditable() {
        return false;
    }
    stdValueToCellValue() {
        return null;
    }
    cellValueToString(cellValue) {
        if (this.validate(cellValue)) {
            return String(cellValue);
        }
        return null;
    }
    validateProperty() {
        return AutoNumberField.propertySchema.validate(this.field.property);
    }
    validateCellValue() {
        return (0, validate_schema_1.joiErrorResult)("computed field shouldn't validate cellValue");
    }
    validateOpenWriteValue() {
        return (0, validate_schema_1.joiErrorResult)("computed field shouldn't validate cellValue");
    }
    getCellValue(record, fieldId) {
        var _a, _b;
        const cellValue = record.data[fieldId];
        const fieldUpdatedMap = (_a = record.recordMeta) === null || _a === void 0 ? void 0 : _a.fieldUpdatedMap;
        if (!fieldUpdatedMap) {
            return null;
        }
        return ((_b = fieldUpdatedMap[fieldId]) === null || _b === void 0 ? void 0 : _b.autoNumber) || cellValue || null;
    }
    validateAddOpenFieldProperty(updateProperty) {
        if (updateProperty === null) {
            return { error: undefined, value: null };
        }
        return this.validateUpdateOpenProperty(updateProperty);
    }
}
exports.AutoNumberField = AutoNumberField;
AutoNumberField.propertySchema = joi_1.default.object({
    nextId: joi_1.default.number().integer().min(0).required(),
    viewIdx: joi_1.default.number().integer().min(0).required(),
    datasheetId: (0, validate_schema_1.datasheetIdString)().required(),
}).required();
AutoNumberField._acceptFilterOperators = [
    types_1.FOperator.Is,
    types_1.FOperator.IsNot,
    types_1.FOperator.IsGreater,
    types_1.FOperator.IsGreaterEqual,
    types_1.FOperator.IsLess,
    types_1.FOperator.IsLessEqual,
    types_1.FOperator.IsEmpty,
    types_1.FOperator.IsNotEmpty,
];
//# sourceMappingURL=auto_number_field.js.map